// 依據目前域名回傳環境名稱，正式機回傳空字串
const getEnvName = () => {
	const { origin } = window;
	if (origin.includes('localhost'))  return 'localhost';
	if (origin.includes('icoach-dev')) return 'dev';
	if (origin.includes('icoach-uat')) return 'uat';
	if (origin.includes('icoach-sit')) return 'sit';
	return '';
};

const useEnvName = () => getEnvName();

export default useEnvName;
